// extracted by mini-css-extract-plugin
export default {"root":"ChatCreateGroupNameField_root__QMBQF"};